import React, { useState, useEffect } from "react";

export default function AboutCard({ title, children, image, reverse, gallery, large, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (gallery) {
      gallery.forEach((item) => {
        const img = new Image();
        img.src = item.src;
      });
    }
  }, [gallery]);

  const nextSlide = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev + 1) % gallery.length);
  };

  const prevSlide = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev - 1 + gallery.length) % gallery.length);
  };

  return (
    <div className="about-accordion">
      <button
        className={`about-accordion-header${open ? " open" : ""}`}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="about-accordion-title">{title}</span>
        <span className="about-accordion-indicator" aria-hidden="true">
          {open ? "−" : "+"}
        </span>
      </button>

      <div className={`about-accordion-body${open ? " open" : ""}`}>
        <div className="about-accordion-body-inner">
          <div className={`about-card-content${reverse ? " reverse" : ""}`}>
            {image && !gallery && (
              <div className="about-media">
                <img src={image} alt={title} loading="eager" />
              </div>
            )}

            {gallery && (
              <div className="about-media gallery-wrapper">
                <button className="gallery-btn left" onClick={prevSlide}>‹</button>
                <div className="gallery-slide">
                  <img src={gallery[current].src} alt={gallery[current].caption} />
                  <p className="caption">{gallery[current].caption}</p>
                  <div className="gallery-dots">
                    {gallery.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === current ? "active" : ""}`}
                        onClick={(e) => { e.stopPropagation(); setCurrent(i); }}
                      />
                    ))}
                  </div>
                </div>
                <button className="gallery-btn right" onClick={nextSlide}>›</button>
              </div>
            )}

            <div className="about-info">
              <p>{children}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
